import {cx} from "@emotion/css";
import {ReactComponent as SvgCampaigns} from "assets/svg/campaigns.svg";

import {designColors} from "~/ui";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmCampaignsIcon: React.FC<IIconBase> = ({id, size = "sm", color = designColors.black, className}) => {
  return <SvgCampaigns id={id} className={cx(simpleIconStyles(size), commonStyles.color(color), className)} />;
};
